// extracted by mini-css-extract-plugin
export default {"wrapper":"Map_wrapper__UNyAE","map":"Map_map__LgrQA"};